// extracted by mini-css-extract-plugin
export default {"scroll":"CategoriesData_scroll__xUD-d"};